import {
  industryOptions,
  companySizeOptions,
  ageOptions,
  genderOptions,
  languageOptions,
} from 'shared/targetingConfigOptions';

type OptionsMap = { [key: string]: string };

export const industryOptionsMap: OptionsMap = industryOptions.reduce(
  (result, industryOption) => ({
    ...result,
    [industryOption.value]: industryOption.label,
  }),
  {}
);

export const companySizeOptionsMap: OptionsMap = companySizeOptions.reduce(
  (result, companySizeOption) => ({
    ...result,
    [companySizeOption.value]: companySizeOption.label,
  }),
  {}
);

export const ageOptionsMap: OptionsMap = ageOptions.reduce(
  (result, ageOption) => ({
    ...result,
    [ageOption.value]: ageOption.label,
  }),
  {}
);

export const genderOptionsMap: OptionsMap = genderOptions.reduce(
  (result, genderOption) => ({
    ...result,
    [genderOption.value]: genderOption.label,
  }),
  {}
);

export const languageOptionsMap: OptionsMap = languageOptions.reduce(
  (result, languageOption) => ({
    ...result,
    [languageOption.value]: languageOption.label,
  }),
  {}
);
